import { createAction } from 'redux-actions';
import {
  ENTITY_SEARCH_REQUEST,
  ENTITY_SEARCH_SUCCESS,
  ENTITY_SEARCH_FAILURE,
  ENTITY_SEARCH_ALL_REQUEST,
  ENTITY_SEARCH_ALL_SUCCESS,
  ENTITY_SEARCH_ALL_FAILURE,
  RESET_OPTIONS,
} from '../../containers/constants';

export const entitySearchRequest = createAction(ENTITY_SEARCH_REQUEST);
export const entitySearchSuccess = createAction(ENTITY_SEARCH_SUCCESS);
export const entitySearchFailure = createAction(ENTITY_SEARCH_FAILURE);

export const entitySearchAllRequest = createAction(ENTITY_SEARCH_ALL_REQUEST);
export const entitySearchAllSuccess = createAction(ENTITY_SEARCH_ALL_SUCCESS);
export const entitySearchAllFailure = createAction(ENTITY_SEARCH_ALL_FAILURE);

export const resetOptions = createAction(RESET_OPTIONS);
